"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AnnualMotorReplaceCarSummaryPanelWidget = void 0;
var React = require("react");
var InfoModal_1 = require("../../../components/modals/InfoModal");
var commonFunctions_1 = require("../../../commonFunctions");
var services_1 = require("@falcon/services");
var FalconQuestionWidgetBase_1 = require("../../FalconQuestionWidgetBase");
var AnnualMotorGlassAndRepairExcessWordingGenerator_1 = require("../../../helpers/annual/motor/AnnualMotorGlassAndRepairExcessWordingGenerator");
var AnnualMotorReplaceCarSummaryPanelWidget = /** @class */ (function (_super) {
    __extends(AnnualMotorReplaceCarSummaryPanelWidget, _super);
    function AnnualMotorReplaceCarSummaryPanelWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.vrnValid = false;
        _this.renderVoluntaryExcessValues = function (voluntaryExcess) {
            var elements = [];
            for (var index = 0; index <= 500; index += 50) {
                elements.push(React.createElement("option", { selected: voluntaryExcess === index, value: index },
                    "\u00A3",
                    index));
            }
            return elements;
        };
        _this.handleSelectOnChangeEvent = function (event) {
            var voluntaryExcess = parseInt(event.target.value, 10);
            var totalExcess = _this.state.compulsoryExcess + voluntaryExcess;
            _this.setState({
                voluntaryExcess: voluntaryExcess,
                totalExcess: totalExcess
            });
            _this.props.onStateChange("vehicles[0].annualVehicleExcess.voluntaryExcess", voluntaryExcess);
            _this.executeNativeEvent(event);
        };
        _this.navigateToEditCarDetailsPage = function () {
            _this.props.engine.navigate("carDetails", false);
        };
        var compulsoryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.compulsoryExcess;
        var voluntaryExcess = _this.props.interaction.vehicles[0].annualVehicleExcess.voluntaryExcess;
        var totalExcess = compulsoryExcess + voluntaryExcess;
        _this.state = {
            compulsoryExcess: compulsoryExcess,
            voluntaryExcess: voluntaryExcess,
            totalExcess: totalExcess,
            vrn: "",
            isVRNValid: false,
        };
        _this.vrnValid = _this.validateVRN(_this.props.interaction.vehicles[0].registrationNumber);
        _this.allDrivers = [_this.props.interaction.policyHolder].concat(_this.props.interaction.additionalDrivers || []);
        _this.validateVRN = _this.validateVRN.bind(_this);
        _this.handleVRNInput = _this.handleVRNInput.bind(_this);
        return _this;
    }
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.componentDidMount = function () {
        var _a;
        this.setState({
            vrn: (_a = this.props.interaction.vehicles[0].registrationNumber) !== null && _a !== void 0 ? _a : "",
            isVRNValid: this.validateVRN(this.props.interaction.vehicles[0].registrationNumber),
        });
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.render = function () {
        var interaction = this.props.interaction;
        var vehicle = interaction.vehicles[0];
        return (React.createElement("div", { className: "replace-car-summary-panel" },
            React.createElement("div", { className: "section-panel your-car-panel replacement-car-panel" },
                React.createElement("img", { className: "main-icon car-front-icon", src: "/".concat(services_1.resourcesHelper.THEME, "/img/wolf-your-car.png"), alt: "Vehicle icon" }),
                React.createElement("div", { className: "section car-details-section pb-0" },
                    React.createElement("div", { className: "replacement-car-panel__main-title car-heading" }, (0, commonFunctions_1.capitalize)("".concat(vehicle.make, ", ").concat(vehicle.model))),
                    React.createElement("div", { className: "section-contents" }, this.renderCarDetails(vehicle))),
                React.createElement("div", { className: "section car-details-section drivers-section" },
                    React.createElement("div", { className: "replacement-car-panel__title" }, "Driver(s)"),
                    React.createElement("div", { className: "section-contents" },
                        React.createElement("div", { className: "detail" }, this.renderVehicleDrivers(vehicle)))),
                React.createElement("div", { className: "section excess-section last-section" },
                    React.createElement("div", { className: "replacement-car-panel__title" },
                        React.createElement("div", null,
                            "Excesses that apply",
                            React.createElement(InfoModal_1.InfoModal, { className: "ml-2", title: "Excess explained" },
                                React.createElement(ExcessExplanation, { vehicle: vehicle })))),
                    React.createElement("div", { className: "section-contents" }, this.renderExcessesSection(vehicle))))));
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.renderInputField = function () {
        return (React.createElement(React.Fragment, null));
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.renderCarDetails = function (vehicle) {
        return (React.createElement(React.Fragment, null,
            React.createElement("div", { className: "text-center" },
                React.createElement("span", { className: "font-weight-bold" }, "Car registration number")),
            this.vrnValid ? React.createElement("div", { className: "number-plate-preview" },
                "(",
                vehicle.registrationNumber,
                ")") :
                React.createElement("div", { className: "link-edit text-center" },
                    React.createElement("div", { className: "col-md-7 d-flex p-0 vrn-text-box mb-3" },
                        React.createElement("div", { className: "vrn-text-box__country-code-wrapper" },
                            React.createElement("span", { className: "vrn-text-box__country-code" }, "GB")),
                        React.createElement("input", { onInput: this.handleVRNInput, value: this.state.vrn, type: "text", id: "registrationNumber", maxLength: 7, className: "form-control vrn-input-field ".concat(this.state.isVRNValid ? "" : "is-invalid"), "aria-label": this.props.question.label })),
                    !this.state.isVRNValid &&
                        React.createElement("p", { className: "text-danger" },
                            React.createElement("span", { className: "text-danger" }, "Please enter your car registration number")),
                    React.createElement("button", { id: "editCar0Details", className: "btn-text", "aria-label": "Edit car details", onClick: this.navigateToEditCarDetailsPage }, "Edit car details"))));
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.renderVehicleDrivers = function (vehicle) {
        var _this = this;
        var vehicleDrivers = [];
        if (vehicle.driverIds) {
            vehicleDrivers = vehicle.driverIds
                .map(function (driverId) { return _this.allDrivers.find(function (driver) { return driverId === driver.personId; }); })
                .filter(function (driver) { return driver !== undefined; });
        }
        return vehicleDrivers.map(function (driver, index) {
            return (React.createElement("div", { key: index, className: "detail-value replace-car-drivers-detail-value" }, "".concat(driver.firstName, " ").concat(driver.lastName),
                " ",
                driver.personId === vehicle.mainDriverId &&
                    React.createElement("span", { className: "font-weight-bold" }, "(main driver)")));
        });
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.renderExcessesSection = function (vehicle) {
        return (React.createElement("div", { className: "text-center font-weight-light" },
            React.createElement("p", null,
                "As a result of replacing the car ",
                React.createElement("strong", null, "your compulsory excess may change"),
                ". Please check and select your voluntary excess from the options available below."),
            React.createElement("div", null, this.renderExcessesPicker()),
            React.createElement("p", null,
                React.createElement("span", null,
                    "Your voluntary excess is added to the compulsory excess to give you the total amount you'll have to pay towards ",
                    React.createElement("span", { className: "font-weight-bold" }, "any claim"),
                    " you make involving accidental damage, fire and theft (but ",
                    React.createElement("span", { className: "font-weight-bold" }, "not"),
                    " glass-only claims)."),
                React.createElement("div", null, "Your total excess applies every time you claim and to every car you're claiming on.")),
            AnnualMotorGlassAndRepairExcessWordingGenerator_1.AnnualMotorGlassAndRepairExcessWordingGenerator.getGlassAndRepairExcessWording(vehicle)));
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.renderExcessesPicker = function () {
        return (React.createElement("div", { className: "excess-picker" },
            React.createElement("div", { className: "voluntary-excess-picker" },
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Compulsory"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value" },
                        "\u00A3",
                        this.state.compulsoryExcess)),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "+"),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "Voluntary"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "input-group" },
                        React.createElement("select", { id: "voluntaryExcess", className: "form-control ".concat(this.getInputValidationClass(), " voluntary-excess-picker__dropdown"), onChange: this.handleSelectOnChangeEvent, onFocus: this.executeNativeEvent, onClick: this.executeNativeEvent }, this.renderVoluntaryExcessValues(this.state.voluntaryExcess)))),
                React.createElement("div", { className: "voluntary-excess-picker__operation" }, "="),
                React.createElement("div", null,
                    React.createElement("div", { className: "voluntary-excess-picker__title" },
                        React.createElement("div", null, "TOTAL"),
                        React.createElement("div", null, "excess")),
                    React.createElement("div", { className: "voluntary-excess-picker__value" },
                        "\u00A3",
                        this.state.totalExcess)))));
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.handleVRNInput = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var vrn, isValid;
            return __generator(this, function (_a) {
                vrn = event.target.value.trim().toUpperCase();
                isValid = this.validateVRN(vrn);
                this.setState({ isVRNValid: isValid });
                this.setState({ vrn: vrn });
                if (isValid) {
                    this.props.onStateChange("vehicles[0].registrationNumber", vrn);
                }
                else {
                    this.props.onStateChange("vehicles[0].registrationNumber", null);
                }
                return [2 /*return*/];
            });
        });
    };
    AnnualMotorReplaceCarSummaryPanelWidget.prototype.validateVRN = function (vrn) {
        return services_1.VEHICLE_REG_NUMBER_REGEX.test(vrn);
    };
    return AnnualMotorReplaceCarSummaryPanelWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.AnnualMotorReplaceCarSummaryPanelWidget = AnnualMotorReplaceCarSummaryPanelWidget;
var ExcessExplanation = function (_a) {
    var annualVehicleExcess = _a.vehicle.annualVehicleExcess;
    return (React.createElement(React.Fragment, null,
        React.createElement("p", { className: "font-weight-extra-light" }, "An excess is the amount you pay towards any claim you make."),
        React.createElement("p", { className: "font-weight-extra-light mb-2" }, "You can choose your own voluntary excess but you will be required to pay the compulsory excess that is applied by us for any accidental damage, fire or theft. See an example below."),
        React.createElement("table", { className: "voluntary-excess-popup__table wolf-excess-explanation-table table table-borderless table-striped mb-4" },
            React.createElement("thead", null,
                React.createElement("tr", null,
                    React.createElement("th", { scope: "col" }),
                    React.createElement("th", { scope: "col" }, "Compulsory excess"),
                    React.createElement("th", { scope: "col", className: "voluntary-excess-popup--dashed" }, "Voluntary excess"),
                    React.createElement("th", { scope: "col" }, "Total excess"))),
            React.createElement("tbody", null,
                React.createElement("tr", null,
                    React.createElement("td", { className: "font-weight-semi-bold" }, "Fire"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.fireExcess, "*")),
                    React.createElement("td", { className: "voluntary-excess-popup--dashed" }, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.voluntaryExcess, "**")),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.totalFire))),
                React.createElement("tr", null,
                    React.createElement("td", { className: "font-weight-semi-bold" }, "Theft"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.theftExcess, "*")),
                    React.createElement("td", { className: "voluntary-excess-popup--dashed" }, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.voluntaryExcess, "**")),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.totalTheft))),
                React.createElement("tr", null,
                    React.createElement("td", { className: "font-weight-semi-bold" }, "Accidental damage"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.adExcess, "*")),
                    React.createElement("td", { className: "voluntary-excess-popup--dashed" }, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.voluntaryExcess, "**")),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.totalAd))),
                React.createElement("tr", null,
                    React.createElement("td", { className: "font-weight-semi-bold" }, "Glass replacement"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.windscreenReplacementExcess)),
                    React.createElement("td", { className: "voluntary-excess-popup--dashed text-align-center" }, "-"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.windscreenReplacementExcess))),
                React.createElement("tr", null,
                    React.createElement("td", { className: "font-weight-semi-bold" }, "Glass repair"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.windscreenRepairExcess)),
                    React.createElement("td", { className: "voluntary-excess-popup--dashed text-align-center" }, "-"),
                    React.createElement("td", null, "\u00A3".concat(annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 : annualVehicleExcess.windscreenRepairExcess))))),
        React.createElement("p", { className: "font-weight-extra-light excess-warning" },
            "* If you decide to use your own repairer rather than one we\u2019ve recommended, an additional \u00A3", annualVehicleExcess === null || annualVehicleExcess === void 0 ? void 0 :
            annualVehicleExcess.nonRecommendedRepairerExcess,
            " excess will be applied to your total excess (compulsory + voluntary)."),
        React.createElement("p", { className: "font-weight-extra-light" }, "** You choose the amount of voluntary excess you\u2019ll pay towards a claim - from \u00A30 up to \u00A3500.")));
};
//# sourceMappingURL=AnnualMotorReplaceCarSummaryPanelWidget.js.map


//////////////////
// WEBPACK FOOTER
// ../falcon-plugins/plugin-falcon-journey/dist/widgets/annual/motor/AnnualMotorReplaceCarSummaryPanelWidget.js
// module id = 3175
// module chunks = 0